import { render } from "./pro-content.vue?vue&type=template&id=500727b3&scoped=true"
import script from "./pro-content.vue?vue&type=script&lang=js"
export * from "./pro-content.vue?vue&type=script&lang=js"

import "./pro-content.vue?vue&type=style&index=0&id=500727b3&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-500727b3"

export default script